import emailjs from '@emailjs/browser'
import { emailjsConfig } from './config/emailjs'

export async function sendRegistrationMail(mail) {
  if (!mail?.to_email) return
  const templateId = emailjsConfig.templates[mail.template]
  const { serviceId, publicKey } = emailjsConfig
  if (!serviceId || !templateId || !publicKey) {
    throw new Error('Die E-Mail konnte nicht gesendet werden.')
  }
  await emailjs.send(serviceId, templateId, mail, { publicKey })
}
